(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $668a05a1bb34bd4a$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"bWXsq":"myspace.2ec469d7.js","eViXj":"chevron-right.8856609f.svg","1INq0":"pattern.41e4058b.css","i1vRG":"youshouldnotbehere.22918078.js"}'));



var $3vtib = parcelRequire("3vtib");
var $bd742ec798c7b4a0$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else $bd742ec798c7b4a0$exports = factory();
})($bd742ec798c7b4a0$exports, function() {
    var payloads = function(tag, start) {
        if (!start) start = 0;
        var length = tag.length;
        return pipeSplit(tag.substr(start, length - start));
    };
    var pipeSplit = function(payload) {
        return payload.split("|");
    };
    var tag = function(tag, attributes, payload) {
        if (!payload) {
            payload = attributes;
            attributes = {};
        }
        var html = "<".concat(tag);
        for(var attribute in attributes)if (attributes.hasOwnProperty(attribute)) html = html.concat(" ", attribute, '="', attributes[attribute], '"');
        return html.concat(">", payload, "</", tag, ">");
    };
    var matchTag = function(match) {
        var action = match[1].substr(0, 1), p;
        switch(action){
            case "!":
                return tag("span", {
                    class: "slack-cmd"
                }, payloads(match[1], 1)[0]);
            case "#":
                p = payloads(match[1], 2);
                return tag("span", {
                    class: "slack-channel"
                }, p.length == 1 ? p[0] : p[1]);
            case "@":
                p = payloads(match[1], 2);
                return tag("span", {
                    class: "slack-user"
                }, p.length == 1 ? p[0] : p[1]);
            default:
                p = payloads(match[1]);
                return tag("a", {
                    href: p[0]
                }, p.length == 1 ? p[0] : p[1]);
        }
    };
    var matchBold = function(match) {
        return safeMatch(match, tag("strong", payloads(match[1])));
    };
    var matchItalic = function(match) {
        return safeMatch(match, tag("em", payloads(match[1])));
    };
    var matchFixed = function(match) {
        return safeMatch(match, tag("code", payloads(match[1])));
    };
    var isWhiteSpace = function(input) {
        return /^\s?$/.test(input);
    };
    var safeMatch = function(match, tag) {
        var prefix_ok = match.index == 0;
        var postfix_ok = match.index == match.input.length - match[0].length;
        if (!prefix_ok) {
            var charAtLeft = match.input.substr(match.index - 1, 1);
            prefix_ok = isWhiteSpace(charAtLeft);
        }
        if (!postfix_ok) {
            var charAtRight = match.input.substr(match.index + match[0].length, 1);
            postfix_ok = isWhiteSpace(charAtRight);
        }
        if (prefix_ok && postfix_ok) return tag;
        return false;
    };
    var publicParse = function(text) {
        if (typeof text === "string") {
            var patterns = [
                {
                    p: /<(.*?)>/g,
                    cb: matchTag
                },
                {
                    p: /\*([^\*]*?)\*/g,
                    cb: matchBold
                },
                {
                    p: /_([^_]*?)_/g,
                    cb: matchItalic
                },
                {
                    p: /`([^`]*?)`/g,
                    cb: matchFixed
                }
            ];
            for(var p = 0; p < patterns.length; p++){
                var pattern = patterns[p], original = text, result;
                while((result = pattern.p.exec(original)) !== null){
                    var replace = pattern.cb(result);
                    if (replace) text = text.replace(result[0], replace);
                }
            }
        }
        return text;
    };
    return {
        parse: publicParse
    };
});


// This sets up the parse server 
const $e2659b17d8cf0fb3$var$STORAGE_ROOT = "fnsz_app_last_";
const $e2659b17d8cf0fb3$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $e2659b17d8cf0fb3$var$PEVENTS_ENDPOINT = "getPersonalEvents";
const $e2659b17d8cf0fb3$var$CEVENTS_ENDPOINT = "getCompanyEvents";
const $e2659b17d8cf0fb3$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $e2659b17d8cf0fb3$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
const $e2659b17d8cf0fb3$var$REST_API_KEY = "fabjEVYWZCwtBWXZ62BF3oAjU7ZzipumKecJidKJ";
$3vtib.initialize($e2659b17d8cf0fb3$var$APP_ID, $e2659b17d8cf0fb3$var$JAVASCRIPT_KEY);
$3vtib.serverURL = $e2659b17d8cf0fb3$var$SERVER_URL;
var $e2659b17d8cf0fb3$var$funsizer, $e2659b17d8cf0fb3$var$srch, $e2659b17d8cf0fb3$var$srchContainer, $e2659b17d8cf0fb3$var$resourceContainer, $e2659b17d8cf0fb3$var$peepInfo, $e2659b17d8cf0fb3$var$modal;
var $e2659b17d8cf0fb3$var$funsizerLoaded = false;
var $e2659b17d8cf0fb3$var$docsLoaded = false;
var $e2659b17d8cf0fb3$var$remindersLoaded = false;
window.addEventListener("load", ()=>{
    gsap.to(document.getElementsByClassName("loader-container")[0], {
        opacity: 1,
        duration: 0.25
    });
    gsap.to(document.getElementsByClassName("loader")[0], {
        scale: 0.5,
        duration: 1,
        ease: "bounce.out",
        repeat: -1,
        yoyo: true
    });
    $e2659b17d8cf0fb3$var$resourceContainer = document.getElementById("resources_data");
    $e2659b17d8cf0fb3$var$srchContainer = document.getElementById("resources_search");
    $e2659b17d8cf0fb3$var$srch = document.getElementById("search_field");
    $e2659b17d8cf0fb3$var$srch.addEventListener("keyup", ()=>{
        $e2659b17d8cf0fb3$var$doSearch();
    });
    document.getElementById("btn_search_cancel").addEventListener("click", ()=>{
        document.getElementById("resources_header").style.display = "flex";
        $e2659b17d8cf0fb3$var$srchContainer.style.display = "none";
        $e2659b17d8cf0fb3$var$srch.value = "";
        $e2659b17d8cf0fb3$var$doSearch();
    });
    document.getElementById("btn_logout").addEventListener("click", ()=>{
        $3vtib.User.logOut().then(()=>{
            $e2659b17d8cf0fb3$var$initFunsizer();
        });
    });
    document.getElementById("btn_search").addEventListener("click", ()=>{
        document.getElementById("resources_header").style.display = "none";
        $e2659b17d8cf0fb3$var$srchContainer.style.display = "flex";
        $e2659b17d8cf0fb3$var$srch.focus();
    });
    document.getElementById("file-input").addEventListener("change", (event)=>{
        console.log("change");
        const file = event.target.files[0];
        const src = URL.createObjectURL(file);
        document.getElementById("myspace-current-image").style.backgroundImage = `url(${src})`;
    });
    $e2659b17d8cf0fb3$var$initFunsizer();
    const hiddens = document.querySelector("nav").getElementsByClassName("hidden");
    for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
        opacity: 1,
        duration: 0.35,
        delay: 0.2 * i
    });
    $e2659b17d8cf0fb3$var$modal = document.querySelector(".modal-wrapper");
    document.getElementById("modal-close-btn").addEventListener("click", ()=>{
        $e2659b17d8cf0fb3$var$modal.style.display = "none";
    });
    document.getElementById("myspace-user-save").addEventListener("click", ()=>{
        $e2659b17d8cf0fb3$var$savePeepEdit();
    });
});
const $e2659b17d8cf0fb3$var$initFunsizer = ()=>{
    $e2659b17d8cf0fb3$var$funsizer = $3vtib.User.current();
    if ($e2659b17d8cf0fb3$var$funsizer) {
        $e2659b17d8cf0fb3$var$getFunsizerInfo().then((info)=>{
            $e2659b17d8cf0fb3$var$peepInfo = info;
            const outerContainer = document.getElementById("funsizer");
            const perp = document.createElement("div");
            perp.classList.add("myspace-user-info");
            outerContainer.prepend(perp);
            perp.addEventListener("click", ()=>{
                $e2659b17d8cf0fb3$var$showEditModal();
            });
            const userImage = document.createElement("img");
            userImage.classList.add("profile-photo");
            userImage.setAttribute("id", "user_image");
            userImage.setAttribute("alt", "Portrait image of the logged in Funsizer");
            userImage.src = info.imageURL;
            perp.append(userImage);
            const userInfo = document.createElement("div");
            userInfo.classList.add("info");
            perp.append(userInfo);
            const userName = document.createElement("p");
            userName.innerHTML = info.name;
            userName.classList.add("name");
            userInfo.append(userName);
            const userRole = document.createElement("p");
            userRole.innerHTML = info.role;
            userInfo.append(userRole);
            const userSince = document.createElement("p");
            const d = new Date(info.since);
            userSince.innerHTML = `Since ${d.getUTCFullYear()}`;
            userSince.classList.add("year");
            userInfo.appendChild(userSince);
            $e2659b17d8cf0fb3$var$funsizerLoaded = true;
            $e2659b17d8cf0fb3$var$showUI();
        }).catch(function(e) {
            $e2659b17d8cf0fb3$var$handleParseError("Error when fetching User Info", e);
        });
        $e2659b17d8cf0fb3$var$getImportantLinks().then((links)=>{
            $e2659b17d8cf0fb3$var$renderImportantLinks(links);
        }).catch(function(e) {
            $e2659b17d8cf0fb3$var$handleParseError("Error when fetching Important Links", e);
        });
        $e2659b17d8cf0fb3$var$getReminders().then((reminders)=>{
            $e2659b17d8cf0fb3$var$renderReminders(reminders);
        }).catch(function(e) {
            $e2659b17d8cf0fb3$var$handleParseError("Error when fetching Reminders", e);
        });
        $e2659b17d8cf0fb3$var$initTimeZones();
    } else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
};
const $e2659b17d8cf0fb3$var$showEditModal = ()=>{
    $e2659b17d8cf0fb3$var$modal.style.display = "flex";
    document.getElementById("myspace-current-image").style.backgroundImage = `url(${$e2659b17d8cf0fb3$var$peepInfo.imageURL})`;
    document.getElementById("myspace-name").value = $e2659b17d8cf0fb3$var$peepInfo.name;
    document.getElementById("myspace-role").value = $e2659b17d8cf0fb3$var$peepInfo.role;
    document.getElementById("myspace-current-image").addEventListener("click", ()=>{
        document.getElementById("file-input").click();
    });
};
const $e2659b17d8cf0fb3$var$savePeepEdit = ()=>{
    const fInput = document.getElementById("file-input");
    var parseFile;
    var maxAllowedSize = 3145728; // 3 MB in bytes
    if (fInput.files.length > 0 && fInput.files[0].size > maxAllowedSize) {
        alert("\uD83C\uDFB5 You're so vain. \uD83C\uDFB5 Plz limit your profile image to 3MB.");
        return;
    }
    if (document.getElementById("myspace-name").value.length < 1) {
        alert("\uD83E\uDD14 What's your name?");
        return;
    }
    if (document.getElementById("myspace-role").value.length < 1) {
        alert("\uD83E\uDD14 What do you do at Funsize?");
        return;
    }
    if (fInput.files.length > 0) {
        const file = fInput.files[0];
        const name = fInput.files[0].name;
        parseFile = new $3vtib.File(name, file);
    }
    if (parseFile) parseFile.save().then(()=>{
        $e2659b17d8cf0fb3$var$savePeepCore(parseFile);
    }, function(error) {
        window.alert("Error while saving peep image", error);
    });
    else $e2659b17d8cf0fb3$var$savePeepCore();
};
const $e2659b17d8cf0fb3$var$savePeepCore = (i)=>{
    const Player = $3vtib.Object.extend("Player");
    const p = new Player();
    p.set("objectId", $e2659b17d8cf0fb3$var$peepInfo.id);
    p.set("Name", document.getElementById("myspace-name").value);
    p.set("Role", document.getElementById("myspace-role").value);
    if (i) p.set("ProfileImage", i);
    p.save().then((r)=>{
        $e2659b17d8cf0fb3$var$modal.style.display = "none";
        $e2659b17d8cf0fb3$var$peepInfo.name = r.get("Name");
        $e2659b17d8cf0fb3$var$peepInfo.role = r.get("Role");
        $e2659b17d8cf0fb3$var$peepInfo.imageURL = r.get("ProfileImage").url();
        localStorage.setObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}funsizer_info`, $e2659b17d8cf0fb3$var$peepInfo);
        const outerContainer = document.getElementById("funsizer").childNodes[0];
        outerContainer.childNodes[0].src = $e2659b17d8cf0fb3$var$peepInfo.imageURL;
        outerContainer.childNodes[1].childNodes[0].innerHTML = $e2659b17d8cf0fb3$var$peepInfo.name;
        outerContainer.childNodes[1].childNodes[1].innerHTML = $e2659b17d8cf0fb3$var$peepInfo.role;
    }, (error)=>{
        alert("Failed updating peep info: " + error);
    });
};
const $e2659b17d8cf0fb3$var$showUI = ()=>{
    if ($e2659b17d8cf0fb3$var$funsizerLoaded && $e2659b17d8cf0fb3$var$docsLoaded && $e2659b17d8cf0fb3$var$remindersLoaded) {
        gsap.to(document.getElementsByClassName("loader-container")[0], {
            opacity: 0,
            duration: 0.25
        });
        const hiddens = document.getElementsByClassName("hidden");
        for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
            opacity: 1,
            duration: 0.35,
            delay: 0.2 * i
        });
    }
};
const $e2659b17d8cf0fb3$var$doSearch = ()=>{
    let search = $e2659b17d8cf0fb3$var$srch.value.toLowerCase();
    for(var i = 0; i < $e2659b17d8cf0fb3$var$resourceContainer.childNodes.length; i++){
        let item = $e2659b17d8cf0fb3$var$resourceContainer.childNodes[i].childNodes[0].innerHTML.toLowerCase();
        if (item.indexOf(search) == -1) $e2659b17d8cf0fb3$var$resourceContainer.childNodes[i].style.display = "none";
        else $e2659b17d8cf0fb3$var$resourceContainer.childNodes[i].style.display = "block";
    }
};
/**
  * Important Links Calls
  */ async function $e2659b17d8cf0fb3$var$getImportantLinks() {
    if (!$e2659b17d8cf0fb3$var$shouldLoadImportantLinksFromAPI()) // console.log('retreiving existing links from storage');
    return localStorage.getObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}links_data`);
    try {
        // console.log('retreiving fresh links from api');
        const links = await $3vtib.Cloud.run("importantLinks");
        const d = new Date();
        const day = d.getDay();
        localStorage.setObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}links_load`, day);
        localStorage.setObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}links_data`, links);
        return localStorage.getObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}links_data`);
    } catch (error) {
        throw error;
    }
}
const $e2659b17d8cf0fb3$var$shouldLoadImportantLinksFromAPI = ()=>{
    const d = new Date();
    const day = d.getDay();
    const lastDay = localStorage.getObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}links_load`);
    const data = localStorage.getObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}links_data`);
    if (lastDay == null || data == null) {
        localStorage.setObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}links_load`, day);
        return true;
    }
    return day != lastDay; // only refresh if a new day
};
var $a2abe57cf3fc1002$exports = {};


$a2abe57cf3fc1002$exports = (parcelRequire("aNJCr")).getBundleURL("bWXsq") + (parcelRequire("iE7OH")).resolve("eViXj");


const $e2659b17d8cf0fb3$var$renderImportantLinks = (links)=>{
    $e2659b17d8cf0fb3$var$docsLoaded = true;
    $e2659b17d8cf0fb3$var$showUI();
    if (links.length == 0) //TODO: render empty state 
    return;
    $e2659b17d8cf0fb3$var$resourceContainer.innerHTML = "";
    for(var i = 0; i < links.length; i++){
        //TODO: Make this whole thing an anchor and the container a div
        const l = document.createElement("li");
        $e2659b17d8cf0fb3$var$resourceContainer.appendChild(l);
        const a = document.createElement("a");
        l.appendChild(a);
        a.innerHTML = links[i].Title;
        a.href = links[i].URL;
        a.target = "_blank";
        const img = document.createElement("img");
        a.appendChild(img);
        const url = new URL($a2abe57cf3fc1002$exports);
        img.src = url;
    }
};
/**
 * Reminders Calls
 */ const $e2659b17d8cf0fb3$var$reminderTimer = 5; //every 5 minutes
var $e2659b17d8cf0fb3$var$currentReminderTimer = 0;
async function $e2659b17d8cf0fb3$var$getReminders() {
    const FunsizeAppMention = $3vtib.Object.extend("FunsizeAppMention");
    const query = new $3vtib.Query(FunsizeAppMention);
    query.descending("createdAt");
    try {
        const reminders = await query.find();
        return reminders;
    } catch (error) {
        throw error;
    }
}
const $e2659b17d8cf0fb3$var$renderReminders = (reminders)=>{
    $e2659b17d8cf0fb3$var$remindersLoaded = true;
    $e2659b17d8cf0fb3$var$showUI();
    const messageList = document.getElementById("message-list");
    messageList.innerHTML = "";
    for(var i = 0; i < reminders.length; i++){
        const s = $bd742ec798c7b4a0$exports.parse(reminders[i].get("message")).replace('<span class="slack-user">03UWU5RDA9</span>', "");
        const li = document.createElement("li");
        const meta = document.createElement("div");
        const postAuthor = document.createElement("p");
        const postDate = document.createElement("p");
        const postTime = document.createElement("p");
        const message = document.createElement("p");
        meta.classList.add("metadata");
        message.classList.add("slack-message");
        const d = new Date(reminders[i].get("postDate"));
        const dh = d.getHours();
        var minutes = d.getMinutes();
        minutes = minutes < 10 ? "0" + minutes : minutes;
        postAuthor.innerHTML = reminders[i].get("name");
        postDate.innerHTML = `${d.toLocaleString("en-US", {
            month: "short"
        })} ${d.getDate()}`;
        postTime.innerHTML = `${dh > 12 ? dh - 12 : dh}:${minutes}${dh >= 12 ? "PM" : "AM"}`;
        message.innerHTML = s;
        messageList.append(li);
        li.append(meta, message);
        meta.append(postAuthor, postDate, postTime);
    }
};
/**
 * User info call
 */ async function $e2659b17d8cf0fb3$var$getFunsizerInfo() {
    const info = localStorage.getObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}funsizer_info`);
    if (!info || !info.id) {
        const query = new $3vtib.Query("Player");
        query.equalTo("Email", $e2659b17d8cf0fb3$var$funsizer.get("email"));
        query.select("Name", "Email", "Role", "StartDate", "ProfileImage");
        try {
            // console.log(query)
            var p = await query.find();
            p = p[0];
            // console.log(p)
            const peep = new Object();
            peep.id = p.id;
            peep.name = p.get("Name");
            peep.role = p.get("Role");
            peep.since = p.get("StartDate");
            peep.imageURL = p.get("ProfileImage") ? p.get("ProfileImage").url() : "./resources/unknown.png";
            localStorage.setObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}funsizer_info`, peep);
            return localStorage.getObject(`${$e2659b17d8cf0fb3$var$STORAGE_ROOT}funsizer_info`);
        } catch (error) {
            throw error;
        }
    }
    return info;
}
/**
 * Timezone calls
 */ const $e2659b17d8cf0fb3$var$initTimeZones = ()=>{
    const current = new Date();
    $e2659b17d8cf0fb3$var$setTime();
    setInterval(()=>{
        $e2659b17d8cf0fb3$var$setTime();
        $e2659b17d8cf0fb3$var$currentReminderTimer++;
        if ($e2659b17d8cf0fb3$var$currentReminderTimer >= $e2659b17d8cf0fb3$var$reminderTimer) {
            // console.log('setting reminders')
            $e2659b17d8cf0fb3$var$currentReminderTimer = 0;
            $e2659b17d8cf0fb3$var$getReminders().then((reminders)=>{
                $e2659b17d8cf0fb3$var$renderReminders(reminders);
            }).catch(function(e) {
                $e2659b17d8cf0fb3$var$handleParseError("Error when fetching Reminders", e);
            });
        }
    }, 60000);
};
const $e2659b17d8cf0fb3$var$setTime = ()=>{
    const current = new Date();
    var minutes = current.getUTCMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const est = new Date(current.toLocaleString("en-US", {
        timeZone: "America/Detroit"
    })).getHours();
    const cst = new Date(current.toLocaleString("en-US", {
        timeZone: "America/Chicago"
    })).getHours();
    const isl = new Date(current.toLocaleString("en-US", {
        timeZone: "Iceland"
    })).getHours();
    const pst = new Date(current.toLocaleString("en-US", {
        timeZone: "America/Los_Angeles"
    })).getHours();
    document.getElementById("pst").innerHTML = `${pst > 12 ? pst - 12 : pst}:${minutes}${pst >= 12 ? "PM" : "AM"}`;
    document.getElementById("isl").innerHTML = `${isl > 12 ? isl - 12 : isl}:${minutes}${isl >= 12 ? "PM" : "AM"}`;
    document.getElementById("cst").innerHTML = `${cst > 12 ? cst - 12 : cst}:${minutes}${cst >= 12 ? "PM" : "AM"}`;
    document.getElementById("est").innerHTML = `${est > 12 ? est - 12 : est}:${minutes}${est >= 12 ? "PM" : "AM"}`;
};
function $e2659b17d8cf0fb3$var$handleParseError(msg, err) {
    switch(err.code){
        case $3vtib.Error.INVALID_SESSION_TOKEN:
            alert("Invalid session token.");
            $3vtib.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}
Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
};
Storage.prototype.getObject = function(key) {
    var value = this.getItem(key);
    return value && JSON.parse(value);
};

})();
//# sourceMappingURL=myspace.2ec469d7.js.map
